import React, { Component, createRef } from "react";
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';

import ordersService from "@services/orders";
import taxService from "@services/tax";

// Components
import Menu from '@components/Menu'
import { confirmAlert } from 'react-confirm-alert';

/* Import Components */
import PDFPrint from "@components/PdfPrint";

import ClipLoader from "react-spinners/ClipLoader";
import { MdArrowBack, MdReceipt, MdSend, MdPrint, MdPerson, MdCategory, MdBarChart, MdCancel, MdEdit, MdDatasetLinked, MdWarehouse, MdTransform, MdDownload, MdNote } from "react-icons/md";

import { TimestampToDate } from '@utils/date'
import { threeDecimal } from '@utils/format'
import { totals } from './utils/totals'

import { EventBus as eventBus } from "@components/EventBus";
import { showGlobalLoading, hideGlobalLoading } from "@services/axiosInstance";
import "./view.css";

const payments = [{
    value: 1,
    label: 'Dinheiro',
},{
    value: 2,
    label: 'Crédito',
},{
    value: 3,
    label: 'Cheque',
},{
    value: 4,
    label: 'TPA',
},{
    value: 8,
    label: 'Frota',
},{
    value: 14,
    label: 'Serviços Internos',
},{
    value: 16,
    label: 'Nota de Crédito',
},{
    value: 104,
    label: 'Transferência',
}];

const translatePayments = (payment) => (payments.find((eachPayment) => eachPayment.value === parseInt(payment, 10)) || {}).label;

class Form extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

  constructor(props) {
    super(props);

    const { match: { params } } = this.props;

    this.state = {
        isSubmiting: false,
        previewUrl: '',
        loaded: false,
        valid: true,
        hideDelete: false,
        date: '',
        doc: '',
        doctype: '',
        provider_name: '',
        provider_nif: '',
        provider_email: '',
        lines: [],
        related: [],
        idempresa: this.props.cookies.get('member_idempresa'),
        idorder: params.idorder,
        idordersource: params.idordersource,
        idproduct: params.idproduct,
        talao: params.talao,
        posto: params.posto,
        serie: params.serie,
        tpv: params.tpv,
        doctypes: [{
            value: 'sales',
            label: 'Talões',
        },{
            value: 'orders',
            label: 'Compras',
        },{
            value: 'returns',
            label: 'Devoluções',
        },{
            value: 'transfer',
            label: 'Transferências',
        },{
            value: 'inventory',
            label: 'Inventário',
        },{
            value: 'earnings',
            label: 'Retificação de stocks (entradas)',
        },{
            value: 'losses',
            label: 'Retificação de stocks (saídas)',
        },{
            value: 'invoices',
            label: 'Faturas',
        },{
            value: 'quotes',
            label: 'Encomendas',
        }]
    };
    this.handleFormCancel = this.handleFormCancel.bind(this);
    this.loadFunction = this.loadFunction.bind(this);
    this.deleteFunction = this.deleteFunction.bind(this);
    this.handleGoBack = this.handleGoBack.bind(this);
    this.handleEmail = this.handleEmail.bind(this);
    this.convertToPurchase = this.convertToPurchase.bind(this);
    this.handlePrint = this.handlePrint.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.printerRef = createRef(); // Define printerRef
  }

  async loadFunction() {
    if (!this.state.loaded) {
        const { match: { params } } = this.props;
        const idempresa = this.props.cookies.get('member_idempresa');

        try {
            const taxes = await taxService.get();
            
            this.setState({ 
                taxes: taxes.map((tax) => ({ ...tax, value: tax.code, label: tax.reason ? `${tax.tax} - ${tax.reason}` : tax.tax })), 
                loaded: true 
            });

            let order;
            if (params.talao && params.posto && params.serie && params.tpv) {
                const orders = await ordersService.getInvoicesById(idempresa, params);
                order = orders[0] || {};
                this.setState({ ...this.state, ...order, date: TimestampToDate(order.date_time), loaded: true });
            } else {
                const orders = await ordersService.getById(idempresa, this.state.idorder);
                order = orders[0] || {};
                
                this.setState({
                    ...this.state,
                    ...order,
                    lines: order.lines ? order.lines.map((line) => {
                        // Calcular total da linha usando a mesma lógica do totals.js
                        const costprice = parseFloat(line.costprice) || 0;
                        const quantity = parseFloat(line.quantity) || 0;
                        const desc1 = parseFloat(line.desc1) || 0;
                        const desc2 = parseFloat(line.desc2) || 0;
                        const desc = parseFloat(line.desc) || 0;
                        
                        const subtotal = costprice * quantity;
                        
                        // Aplicar descontos sequencialmente
                        let desconto = 0;
                        let subtotalWithDiscount = subtotal;
                        
                        if (desc1 > 0) {
                            const desc1Amount = subtotal * (desc1 / 100);
                            desconto += desc1Amount;
                            subtotalWithDiscount -= desc1Amount;
                        }
                        
                        if (desc2 > 0) {
                            const desc2Amount = subtotalWithDiscount * (desc2 / 100);
                            desconto += desc2Amount;
                            subtotalWithDiscount -= desc2Amount;
                        }
                        
                        if (desc > 0) {
                            desconto += desc * quantity;
                            subtotalWithDiscount -= desc * quantity;
                        }
                        
                        const totalWithoutIVA = subtotal - desconto;
                        const ivaTax = (taxes.find(({code}) => code === line.iva) || { tax: 0 }).tax;
                        const total = totalWithoutIVA + (totalWithoutIVA * (ivaTax / 100));
                        
                        return {
                            ...line,
                            iva: taxes.find(({code}) => code === line.iva),
                            total: threeDecimal(subtotal) // Mostrar apenas costprice × quantity (sem IVA e sem descontos)
                        };
                    }) : [],
                    date: TimestampToDate(order.date_time),
                    hideDelete: ['invoices', 'inventory', 'earnings', 'losses'].includes(order.doctype),
                    loaded: true
                });
            }
        } catch (error) {
            console.error(error);
        }
    }
  }

  async deleteFunction() {
    confirmAlert({
        title: 'Confirmação',
        message: `Tem a certeza que deseja apagar a compra ${this.state.doc}?`,
        buttons: [
            {
                label: 'Sim',
                onClick: async () => {
                    try {
                        const response = await ordersService.unset(this.props.cookies.get('member_idempresa'), this.state.idorder);
                        if (response !== 'NOK') {
                            this.handleFormCancel();
                        }
                    } catch (error) {
                        console.error(error);
                    }
                }
            },
            {
                label: 'Não',
                onClick: () => {}
            }
        ]
    });
  }

  handleFormCancel() {
    const { history } = this.props;
    history.push('/orders');
  }

  handleGoBack() {
    const { history } = this.props;
    if (window.history.length > 1) {
      // Existe histórico anterior — voltar
      history.goBack();
    } else {
      // Tenta fechar a janela
      window.close();

      // Se não fechar, redireciona
      setTimeout(() => {
        if (!window.closed) {
          history.push('/orders'); // Altera esta rota conforme necessário
        }
      }, 100);
    }
  }

  async handleEmail() {
    let email = prompt("Email:", this.state.provider_email);
    
    if (email) {
      await this.setState({ isSubmiting: true });
      try {
        const response = await ordersService.email({
          idempresa: this.props.cookies.get('member_idempresa'),
          type: this.state.doctype,
          idorder: this.state.idorder,
          email: email
        });
        if (response === 'OK') {
          await this.setState({ isSubmiting: false });
          alert('Email enviado com sucesso');
        } else {
          alert('Erro ao enviar email');
        }
      } catch (error) {
        console.error(error);
        alert('Erro ao enviar email');
        await this.setState({ isSubmiting: false });
      }
    }
  }

  convertToPurchase() {
    const { history } = this.props;
    
    // Preparar dados para pré-preenchimento
    const prefilledData = {
        fromQuote: true,
        quoteDoc: this.state.doc,
        doctype: 'orders',
        idprovider: this.state.idprovider,
        provider_name: this.state.provider_name,
        idposto: this.state.idposto,
        posto_name: this.state.posto_name,
        obs: this.state.obs ? `${this.state.obs}\n\nConvertido da encomenda ${this.state.doc}` : `Convertido da encomenda ${this.state.doc}`,
        lines: this.state.lines.map((line) => ({
        idproduct: line.idproduct,
        product_name: line.product_name,
        quantity: line.quantity,
        idposto: line.idposto,
        posto_name: line.posto_name,
        }))
    };
    
    // Redirecionar para formulário de nova compra com dados pré-preenchidos
    history.push('/orders/new/orders', { prefilledData });
  }

  async handlePrint() {
    showGlobalLoading('A preparar documento para impressão...');
    
    await this.setState({ isSubmiting: true });
    await this.setState({ previewUrl: `https://eposgestofinal.com/api/orders/pdf.php?idempresa=${this.props.cookies.get('member_idempresa')}&type=${this.state.doctype}&idorder=${this.state.idorder}` });
      
    // eslint-disable-next-line no-unused-expressions
    this.printerRef.current?.handlePrint().then(async () => {
      await this.setState({ isSubmiting: false });
      hideGlobalLoading()
    });
  }

  async handleDownload() {
    try {
      const idempresa = this.props.cookies.get('member_idempresa');
      const { doctype, idorder } = this.state;
      
      const response = await ordersService.downloadCsv(idempresa, doctype, idorder);
      
      // Create blob URL and trigger download
      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `order_${idorder}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erro ao fazer download:', error);
      alert('Erro ao fazer download do ficheiro CSV');
    }
  }

  render() {
    const { location, history } = this.props;
    const {
        loaded,
        valid,
        hideDelete,
        doc,
        obs,
        doctype,
        doctypes,
        date,
        related,
        provider_name,
        provider_nif,
        posto_name,
        lines,
        serie,
        tpv,
        idproduct,
        payment,
        customer_name,
        date_time,
        idordersource,
        idorder,
        taxes,
        isSubmiting,
        previewUrl,
    } = this.state;
    const cookies = new URLSearchParams(location.search);

    const results = totals(lines, typeof doctype === 'string' ? doctype : doctype.value, taxes);

    const desconto = results.desconto;
    const total = results.total;
    const subtotal = results.subtotal;
    const iva = results.iva;

    return (
        <div>
            <Menu
                loadFunction={this.loadFunction}
                location={location}
                history={history}
                newCookies={cookies}
            />
            <div className="fullContainer" style={{ maxWidth: '100%', backgroundColor: !valid ? '#910000' : '#262626' }}>
                <div className="col-xs-12">
                <ol
                    style={{
                    textAlign: 'left',
                    marginTop: '75px',
                    }}
                    className="breadcrumb"
                >
                    <li>
                    <a href="http://eposgestofinal.com/index.php">Portal</a>
                    </li>
                    <li>
                    <a href="/orders">Compras</a>
                    </li>
                    <li className="active">
                    <span>Detalhes do documento</span>
                    </li>
                </ol>
                </div>
            </div>

            <div className="invoice-container">
            {/* Header Bar */}
            <div className="header-bar" style={{ backgroundColor: !valid ? '#910000' : '#262626' }}>
                <div className="header-content">
                <button className="btn-back" onClick={this.handleGoBack}>
                    <MdArrowBack size={20} /> <span>Voltar</span>
                </button>
                <div className="document-info">
                    <MdReceipt size={24} />
                    <div>
                    <h1>{doc} {!valid ? '(anulado)' : ''}</h1>
                    {['quotes'].includes(doctype) ? (
                        <p>
                            {new Date(date_time * 1000).toLocaleString('pt-PT', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                            })}
                        </p>
                    ) : (
                        <p>
                            {new Date(date_time * 1000).toLocaleString('pt-PT', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit'
                            })}
                        </p>
                    )}
                    </div>
                </div>
                <div className="header-actions">
                    {!['quotes'].includes(doctype) && valid && !hideDelete ? (
                        <button className="btn-action" onClick={this.deleteFunction}>
                        { isSubmiting ? <ClipLoader size={15} /> : <MdCancel size={18} />} <span>Anular</span>
                        </button>
                    ) : null}
                    {['orders'].includes(doctype) ? (
                        <button className="btn-action" onClick={() => window.location.href = `/orders/edit/${doctype}/${idorder}`}>
                        { isSubmiting ? <ClipLoader size={15} /> : <MdEdit size={18} />} <span>Editar</span>
                        </button>
                    ) : null}
                    {['quotes'].includes(doctype) ? (
                        <button className="btn-action" onClick={this.convertToPurchase}>
                        { isSubmiting ? <ClipLoader size={15} /> : <MdTransform size={18} />} <span>Converter em compra</span>
                        </button>
                    ) : null}
                    {['quotes'].includes(doctype) ? (
                        <button className="btn-action" onClick={this.handleDownload}>
                        { isSubmiting ? <ClipLoader size={15} /> : <MdDownload size={18} />} <span>Download CSV</span>
                        </button>
                    ) : null}
                    {['quotes', 'orders', 'returns', 'transfer', 'inventory'].includes(doctype) ? (
                        <button className="btn-action" onClick={this.handleEmail}>
                        { isSubmiting ? <ClipLoader size={15} /> : <MdSend size={18} />} <span>Enviar Email</span>
                        </button>
                    ) : null}
                    {['quotes', 'orders', 'returns', 'transfer', 'inventory'].includes(doctype) ? (
                        <button className="btn-action" onClick={this.handlePrint}>
                        { isSubmiting ? <ClipLoader size={15} /> : <MdPrint size={18} />} <span>Imprimir</span>
                        </button>
                    ) : null}
                </div>
                </div>
            </div>

            <div className="content-wrapper">
                {/* Main Content */}
                <div className="invoice-content">
                {/* Client and Document Info */}
                <div className="info-cards-container">
                    {['orders', 'quotes', 'returns'].indexOf(doctype) >= 0 ? (
                        <div className="info-card client-card">
                        <div className="card-header">
                            <MdPerson size={20} />
                            <h2>Informação do Fornecedor</h2>
                        </div>
                        <div className="card-content">
                            <h3>{provider_name || ''}</h3>
                            <div className="detail-item">
                                <span>NIF: {provider_nif}</span>
                            </div>
                        </div>
                        </div>
                    ) : null}
                    <div className="info-card payment-card">
                    <div className="card-header">
                        <MdReceipt size={20} />
                        <h2>Informação do Documento</h2>
                    </div>
                    <div className="card-content">
                    <div className="detail-item">
                            <MdCategory size={16} />
                            <span>
                            Tipo: { (doctypes.find((docType) => docType.value === doctype) || {}).label }
                            </span>
                        </div>
                        {['returns'].indexOf(doctype) >= 0 && (
                            <>
                                <div className="detail-item">
                                    <MdDatasetLinked size={16} />
                                    <span>Documento original: {idordersource != -1 ? idordersource : 'Indiferenciado'}</span>
                                </div>
                            </>
                        )}
                        {['quotes', 'inventory'].indexOf(doctype) >= 0 ? (
                            <div className="detail-item">
                                <MdWarehouse size={16} />
                                <span>
                                Posto: { posto_name || 'N/A' }
                                </span>
                            </div>
                        ) : null}
                        {['inventory', 'earnings', 'losses'].indexOf(doctype) >= 0 && (
                            <>
                                <div className="detail-item">
                                    <MdDatasetLinked size={16} />
                                    <span>Documentos Associados:</span>
                                </div>
                                <div className="detail-item">
                                    <table className="table table-bordered table-hover table-sortable" style={{ width: '250px' }}>
                                        <tbody>
                                        {related.map((rel) => (
                                            <tr>
                                                <td>
                                                    <a href={ `/orders/${rel.idorder}` }>{(doctypes.find((docType) => docType.value === rel.doctype) || { label: rel.doc }).label}</a>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                    </div>
                </div>

                {/* Document Observations */}
                {obs && (
                    <div className="observations-section">
                    <div className="section-header">
                        <MdNote size={24} />
                        <h2>Observações do Documento</h2>
                    </div>
                    <div className="observations-content">
                        <p>{obs}</p>
                    </div>
                    </div>
                )}

                {/* Products Table */}
                <div className="products-section">
                    <div className="section-header">
                    <MdBarChart size={24} />
                    <h2>Produtos e Serviços</h2>
                    </div>
                    <div className="table-container">
                    <table className="products-table">
                        <thead>
                        <tr>
                            <th className="text-center">Produto</th>
                            <th className="text-center">Quantidade</th>
                            {['orders', 'returns', 'transfer'].indexOf(doctype) >= 0 && (doctype === 'returns' ? idordersource !== '-1' : true) ? (
                                <th className="text-center">Preço de Compra</th>
                            ) : null}
                            {['orders', 'returns'].indexOf(doctype) >= 0 && (doctype === 'returns' ? idordersource !== '-1' : true) ? (
                                <>
                                    <th className="text-center">Desc1</th>
                                    <th className="text-center">Desc2</th>
                                    <th className="text-center">Desc(€)</th>
                                </>
                            ) : null}
                            {['inventory', 'quotes'].indexOf(doctype) < 0 && (doctype === 'returns' ? idordersource !== '-1' : true) ? (
                                <th className="text-center">IVA</th>
                            ) : null}
                            {doctype === 'inventory' ? (
                                <th className="text-center">Diferença</th>
                            ) : null}
                            {doctype === 'transfer' ? (
                                <th className="text-center">Posto origem</th>
                            ) : null}
                            {['inventory', 'sales', 'quotes'].indexOf(doctype) < 0 ? (
                                <th className="text-center">Posto</th>
                            ) : null}
                            {['orders', 'returns'].indexOf(doctype) >= 0 && (doctype === 'returns' ? idordersource !== '-1' : true) ? (
                                <th className="text-center">Total</th>
                            ) : null}
                        </tr>
                        </thead>
                        <tbody>
                        {lines.map((line, index) => (
                            <tr key={index} style={{
                                backgroundColor: line['product_inativo'] === 't' ? 'black' : (idproduct === line['idproduct'] && '#f5f5f5'),
                                color: line['product_inativo'] === 't' ? 'yellow' : 'black',
                            }}>
                                <td style={{
                                    maxWidth: '300px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}>
                                    {line['product_inativo'] === 't' ? '(inativo)' : ''} [{line['idproduct']}] {line['product_name']}
                                </td>
                                <td>
                                    {line['quantity']}
                                </td>
                                {['orders', 'returns', 'transfer'].indexOf(doctype) >= 0 && (doctype === 'returns' ? idordersource !== '-1' : true) ? (
                                    <td>
                                        {parseFloat(line['costprice']).toFixed(3)}
                                    </td>
                                ) : null}
                                {['orders', 'returns'].indexOf(doctype) >= 0 && (doctype === 'returns' ? idordersource !== '-1' : true) ? (
                                    <>
                                        <td>
                                            {line['desc1'] > 0 ? line['desc1'] : ''}
                                        </td>
                                        <td>
                                            {line['desc2'] > 0 ? line['desc2'] : ''}
                                        </td>
                                        <td>
                                            {line['desc'] > 0 ? line['desc'] : ''}
                                        </td>
                                    </>
                                ) : null}
                                {['inventory', 'quotes'].indexOf(doctype) < 0 && (doctype === 'returns' ? idordersource !== '-1' : true) ? (
                                    <td>
                                        {(line['iva'] || {}).tax}
                                    </td>
                                ) : null}
                                {doctype === 'inventory' ? (
                                    <td>
                                        {line['diff']}
                                    </td>
                                ) : null}
                                {doctype === 'transfer' ? (
                                    <td>
                                        {line['postosource_name']}
                                    </td>
                                ) : null}
                                {['inventory', 'sales', 'quotes'].indexOf(doctype) < 0 ? (
                                    <td>
                                        {line['posto_name']}
                                    </td>
                                ) : null}
                                {['orders', 'returns'].indexOf(doctype) >= 0 && (doctype === 'returns' ? idordersource !== '-1' : true) ? (
                                    <td>
                                        {line['total']}
                                    </td>
                                ) : null}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    </div>
                </div>

                {/* Totals */}
                {!['quotes'].includes(doctype) && ['inventory'].indexOf(doctype) < 0 && (doctype === 'returns' ? idordersource !== '-1' : true) ? (
                    <div className="totals-section">
                        <div className="totals-card">
                        <div className="totals-row">
                            <span>Subtotal (s/IVA)</span>
                            <span>{threeDecimal(subtotal)} €</span>
                        </div>
                        {desconto ? (
                            <div className="totals-row">
                                <span>Descontos</span>
                                <span>{threeDecimal(desconto)} €</span>
                            </div>
                        ) : null}
                        <div className="totals-row">
                            <span>IVA</span>
                            <span>{threeDecimal(iva)} €</span>
                        </div>
                        <div className="totals-row total">
                            <span>Total (c/IVA)</span>
                            <span>{threeDecimal(total)} €</span>
                        </div>
                        </div>
                    </div>
                ) : null}
                </div>
            </div>
            </div>
            <PDFPrint ref={this.printerRef} pdfUrl={previewUrl} />
        </div>
    );
  }
}

const buttonStyle = {
  margin: "10px 10px 10px 10px"
};

export default withCookies(Form);
